import React, {
  useEffect,
  useReducer,
  useState,
} from 'react';
import FormFilter from './components/filter';
import {
  Container,
  Button,
} from './styles';
import { T2 } from '../../../styles/titles';
import { InitialState, Reducer } from './actions/reducer';
import {
  PainelVendasFilterProps,
} from '../../../global/dataTransferObjects/transacoesTempoReal';
import LiveTable from './components/liveTable';
import LoadingOverlay from '../../../components/LoadingOverlay';
import ZeroState from '../../../components/ZeroState';
import RecebiveisServices from "./services/RecebiveisServices";
import { can, PortalPermissions } from "../../../config/permissions";

const PainelDeRecebiveis: React.FC = () => {
  const [state, dispatch] = useReducer(Reducer, InitialState);
  const [pageSize] = useState<number>(20);
  const [page] = useState<number>(0);
  const [filterData, setFilterData] = useState<any>(null);
  const [totals, setTotals] = useState();
  const recebiveisServices = new RecebiveisServices();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasMerchantId, setHasMerchantId] = useState(false);

  const handleFilter = async (filter: PainelVendasFilterProps) => {
    setFilterData(filter);
  };

  const handleDownload = async (filter?: PainelVendasFilterProps) => {
    try {
      setIsLoading(true);
      await recebiveisServices.downloadRecebiveis('xls', filter);
    } catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleCsvDownload = async (filter?: PainelVendasFilterProps) => {
    try {
      setIsLoading(true);
      await recebiveisServices.downloadRecebiveis('csv', filter);
    } catch (error){
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOfxDownload = async (filter?: PainelVendasFilterProps) => {
    const selectedCompany = JSON.parse(
      localStorage.getItem('selectedCompany') || 'null'
    );

    if (!selectedCompany?.merchantId) return;

    try {
      setIsLoading(true);
      await recebiveisServices.downloadRecebiveisOfx(filter);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const selectedCompany = JSON.parse(
      localStorage.getItem('selectedCompany') || 'null'
    );
    setHasMerchantId(!!selectedCompany?.merchantId);
  }, []);

  if (state.zeroState) {
    return (
      <ZeroState />
    )
  }

  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <T2>Painel De Recebíveis</T2>
      <FormFilter totals={totals} onFormSubmit={handleFilter} />
      <div>
        {can(PortalPermissions.transacoes.recebiveis.exportar) && (
          <Button onClick={() => { handleDownload(filterData) }} style={{ marginBottom: '25px', marginRight: '24px', width: '150px', alignSelf: 'start' }}>Download Xlsx</Button>
        )}
        {can(PortalPermissions.transacoes.recebiveis.exportar) && (
          <Button onClick={() => { handleCsvDownload(filterData) }} style={{ marginBottom: '25px', marginRight: '24px', width: '150px', alignSelf: 'start' }}>Download Csv</Button>
        )}
        {hasMerchantId && can(PortalPermissions.transacoes.recebiveis.exportar) && (
          <Button
            loading={isLoading}
            onClick={() => handleOfxDownload(filterData)}
          >
            Download OFX
          </Button>
        )}
      </div>
      <LiveTable dataFilter={filterData} getTotals={(totals) => setTotals(totals)} />
    </Container>
  );
};

export default PainelDeRecebiveis;
